import React, { forwardRef, useState, useImperativeHandle, useCallback } from 'react';
import { useSelector } from 'react-redux';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import CloseRounded from '@mui/icons-material/CloseRounded';
import { Dialog, DialogContent, Box} from '@mui/material';

const ModalController = (props, ref) => {
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
	const [screens, setScreens] = useState([]);
	const {webConfig} = useSelector(state => state.core);

	const handleHide = useCallback(() => {
		if (!screens[screens.length - 1]?.closable) return;

		const { current: { hide } } = ref;
		hide();
	}, [screens, ref]);

	useImperativeHandle(ref, () => ({
		show: (screen, replace) => {
			const newScreens = [...screens];

			if (replace) {
				newScreens.pop();
			}
			newScreens.push(screen);

			setScreens(newScreens);
		},

		hide: (key) => {
			let newScreens = [...screens];
			if (key) {
				newScreens = screens.filter(s => s.key !== key);
			}
			else {
				newScreens.pop();
			}
			setScreens(newScreens);
		},

		updateSetting: (setting) => {
			const newScreens = [...screens];
			const lastScreenIndex = newScreens.length -1;
			const lastScreen = newScreens[lastScreenIndex];

			newScreens[lastScreenIndex] = {
				...lastScreen,
			};

			setScreens(newScreens);
		},

		hideAll: () => {
			setScreens([]);
		},
	}), [screens]);

	return (
		<>
			{screens.map(s => {
				const Component = s.component;

				return (
					<Dialog
						className='modal-zIndex'
						key={s.key}
						open
						fullScreen={(isMobile && s.fullScreenMobile) || s.fullScreenDesktop}
						onClose={handleHide}
						maxWidth={s.maxWidth}
						PaperProps={
							!isMobile && !s.fullScreenDesktop 
							? 
								{style: { borderRadius: s.borderRadius }} 
							: 
							isMobile && !s.fullScreenMobile
							?
								{style: { borderRadius: s.borderRadius, width: '600px' }} 
							: 
								{style: { borderRadius: '0' }}
							}
					>
						{s.title || !s.hideCloseButton 
						?
						<Box 
							sx={{ 
								px: s.componentProps?.px ?? { xs: 2, md: 3.5 },
								pt: 3.5,
								display: 'flex', 
								flexDirection: 'row',
								alignItems: s.hideCloseButton && s.title ? 'flex-start' : !s.hideCloseButton && !s.title ? 'flex-end' : 'center', 
								justifyContent: s.hideCloseButton && s.title ? 'flex-start' : !s.hideCloseButton && !s.title ? 'flex-end' : 'space-between',
								background: s.background ?? 'white',
								direction: webConfig.dir,
							}}
						>
							{s.title &&
							<span 
								style={{ textAlign: webConfig.dir === 'ltr' ? 'left' : 'right', fontWeight: '800', fontSize: { xs: '15px', md: '18.6px', background: '#F5F5F7' } }}
							>
								{s.title}
							</span>
							}

							{!s.hideCloseButton
							&&
							<Box
								onClick={handleHide}
								sx={{ width: 28, height: 28, cursor: 'pointer', background: s.background ?? 'white' }}
							>
								<CloseRounded 
									sx={{ width: 28, height: 28, color: '#0C1C40' }} 
								/>
							</Box>
							}
						</Box>
						: null
						}

						<DialogContent
							sx={{
								minWidth: s.minWidth ? { md: s.minWidth } : { md: 320 },
								minHeight: 220,
								py: s.componentProps?.py ?? '25px !important',
								px: s.componentProps?.px ?? { xs: 2, md: 3.5 }, 
								transition: 'all 500ms',
								background: s.background ?? 'white',
								direction: `${webConfig.dir} !important`,
								fontFamily: `${webConfig.fontFamily} !important`,
							}}
						>
							{s.message}
							{Component ? <Component {...s.componentProps} handleHide={handleHide} /> : null}
							{s.content ? s.content : null}
						</DialogContent>

					</Dialog>
				);
			})}
		</>
	);
};

export default forwardRef(ModalController);

